export default __webpack_public_path__ + "static/media/heartrate.39ba5e64.png";